// extracted by mini-css-extract-plugin
export default {"currentIssues":"CurrentIssues_currentIssues__uCWSp","scroll-container":"CurrentIssues_scroll-container__Jw84t"};